export interface LoadingStatus {
  loading: boolean;
  description?: string;
}

export const INITIAL_LOADING_STATUS = { id: 'app_init' };
